import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MEMBER_FEATURE_KEY, MemberState } from './member.reducer';

export const selectMemberState = createFeatureSelector<MemberState>(MEMBER_FEATURE_KEY);

export const selectMembers = createSelector(selectMemberState, (state) => state?.data ?? null);
export const selectMemberDetail = createSelector(selectMemberState, (state) => state?.detail ?? null);
export const selectMembersQuery = createSelector(selectMemberState, (state) => state?.query ?? null);
export const selectMembersLoading = createSelector(selectMemberState, (state) => state?.loading ?? false);
export const selectMembersError = createSelector(selectMemberState, (state) => state?.error ?? null);
